import { VNode, DirectiveFunction } from 'vue/types';
import { DirectiveBinding } from 'vue/types/options';

const useAcl = (checker: (value: string | string[], or: boolean) => boolean): DirectiveFunction => {
	return (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
		if (!checker(binding.value, binding.arg === 'or')) {
			const comment = document.createComment(' ');
			Object.defineProperty(comment, 'setAttribute', {
				value: () => undefined,
			});
			vnode.elm = comment;
			vnode.text = ' ';
			vnode.isComment = true;
			vnode.context = undefined;
			vnode.tag = undefined;
			vnode.data!.directives = undefined;
			if (vnode.componentInstance) {
				// @ts-ignore
				vnode.componentInstance.$el = comment;
			}
			if (el.parentNode) {
				el.parentNode.replaceChild(comment, el);
			}
		}
	};
};

export default useAcl;